import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight } from "@fortawesome/free-solid-svg-icons";

/**
 * Handles change of alignment for text block.
 *
 * @param {Object}   canvas   FabricJS Canvas Object
 *
 * @returns {Object}
 */
export default function Alignment({ canvas }) {
  const updateTextAlignment = (alignment = "left") => {
    const activeObject = canvas.getActiveObject() || null;
    if (activeObject === null) {
      return;
    }
    activeObject.set('textAlign', alignment);
    canvas.renderAll();
  }

  return (
    <div id="alignmentTool" className="text-tool-inner">
      <div>Alignment</div>
      <button className="font-type" onClick={() => updateTextAlignment('left')}>
        <FontAwesomeIcon icon={faAlignLeft} />
        <i className="fa fa-align-left" aria-hidden="true"></i>
      </button>
      <button className="font-type" onClick={() => updateTextAlignment('center')}>
        <FontAwesomeIcon icon={faAlignCenter} />
        <i className="fa fa-align-center" aria-hidden="true"></i>
      </button>
      <button className="font-type" onClick={() => updateTextAlignment('right')}>
        <FontAwesomeIcon icon={faAlignRight} />
        <i className="fa fa-align-right" aria-hidden="true"></i>
      </button>
      <button className="font-type" onClick={() => updateTextAlignment('justify')}>
        <FontAwesomeIcon icon={faAlignJustify} />
        <i className="fa fa-align-justify" aria-hidden="true"></i>
      </button>
    </div>
  );
}
